/**************************************************
 * Nombre:       Seccion_Simulador_Comisiones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Tab, Tabs, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import pasivos from '../../Recursos/pasivos.png'
import {theme} from "../../Tema";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_FECHA_DATO,
    CASILLA_MONEDA,
    CASILLA_TITULO_DATO,
    CASILLA_TITULO_DINERO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {Calculate, Groups, PointOfSale} from '@mui/icons-material'
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {usuarioContext} from "../../App";
import {where} from "firebase/firestore";
import Dialogo_Comision from "../Dialogos/Dialogo_Comision";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Dialogo_Comision_Ver from "../Dialogos/Dialogo_Comision_Ver";
import {ITEMPASIVOS} from "../../Constantes";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


const Seccion_Simulador_Comisiones = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const [wheres, setWheres] = useState([where('idUsuario', '==', cData.usuario.id)]);
    const [wheresPasivos, setWheresPasivoc] = useState([where('fecha', '==', 'none')]);
    const {
        props,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'simulaciones', wheres: wheres})
    const {
        props: propsPasivos,
        setData: setPasivos,
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'pasivos', wheres: wheresPasivos})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Comision,
        titulo: 'Detalles de la simulacion',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVer, abrir: abrirVer} = useDialogo({
        Componente: Dialogo_Comision_Ver,
        titulo: 'Resultados de la simulacion',
        realizado: cargarNuevamente
    })
    const [escogida, setEscogida] = useState('Activos')

    const click = (id, data) => {

        switch (id) {
            case 'resultados':
                abrirVer(data)
                break
            default :
                abrir(data)
        }
    }


    useEffect(() => {
        setPasivos(ITEMPASIVOS)
    }, [escogida]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
            >

                <Dialogo/>

                <DialogoVer/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>Simulador
                                        de Comision</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Calcula fácilmente las ganancias que puedes obtener por cada producto vendido y
                                        proyecta tus resultados con nuestro simulador de comisiones
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: sCell ? 2 : 0}}>

                            <Tabs value={escogida} onChange={(e, s) => setEscogida(s)} aria-label="basic tabs example">
                                <Tab value={'Activos'} icon={<PointOfSale/>} label="Ingresos Activos"/>
                                <Tab value={'Pasivos'} icon={<Groups/>} label="Ingresos Pasivos"/>
                            </Tabs>

                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: 6, px: sCell ? 0 : 4}}>

                    {escogida === 'Activos' ?
                        <Tabla_Filtro
                            nombre={'Historial de simulaciones'}
                            descripcion={`${props.numeroFilas} en historial`}
                            filtros={filtros}
                            datosCabecera={datosCabecera}
                            {...props}
                            botonesData={botonesData}
                            clickData={click}
                            clickAgregar={abrir}
                            // funcionBuscar={funcionBuscar}
                            //  botones={[]}
                        />

                        :

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{px: 1}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Zoom>
                                    <img src={pasivos} width={'100%'} height={'auto'}/>
                                </Zoom>
                            </Grid>

                        </Grid>

                    }
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Simulador_Comisiones


const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Producto',
        direccion: 'left',
        propiedad: 'producto',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valorProducto',
        tipo: CASILLA_MONEDA

    },
    {
        nombre: 'Tipo',
        direccion: 'left',
        propiedad: 'tipo',
        titulo: 'rango',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Valor impuesto',
        direccion: 'left',
        propiedad: 'valorImpuesto',
        titulo: 'zona',
        decimales: 2,
        tipo: CASILLA_TITULO_DINERO

    }

]


const botonesData = [
    {
        nombre: 'Resultados',
        id: 'resultados',
        icono: Calculate
    }
]



